import { defineComponent as n, createBlock as r, openBlock as l, unref as p, mergeProps as c, withCtx as d, createElementVNode as o } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconGrade",
  __name: "IconGrade",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const a = t;
    return (i, e) => (l(), r(p(m), c(a, { "view-box": "0 0 24 24" }), {
      default: d(() => [...e[0] || (e[0] = [
        o("path", {
          "fill-rule": "evenodd",
          d: "M4.5 2.759a1.25 1.25 0 0 0-1.25 1.25V8.73c0 9.392 7.29 12.1 8.395 12.455a1.147 1.147 0 0 0 .71 0C13.46 20.83 20.75 18.122 20.75 8.73V4.01a1.25 1.25 0 0 0-1.25-1.25h-15m.25 5.97V4.26h14.5v4.47c0 8.106-6.024 10.573-7.25 10.992-1.226-.419-7.25-2.886-7.25-10.992",
          "clip-rule": "evenodd"
        }, null, -1),
        o("path", { d: "M12.506 7.388a.548.548 0 0 0-1.012 0l-.88 2.117L8.327 9.69a.548.548 0 0 0-.313.963l1.741 1.491-.532 2.23a.548.548 0 0 0 .82.596L12 13.774l1.957 1.195a.548.548 0 0 0 .819-.595l-.532-2.23 1.741-1.492a.548.548 0 0 0-.313-.963l-2.285-.184-.88-2.117" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
